class GravixProductV2 {
  constructor(productInfo) {
    this.productInfo = productInfo;
    this.sectionId = productInfo.dataset.section;
    this.mobileBar = productInfo.querySelector('[data-mobile-purchase-bar]');
    this.mobileButton = productInfo.querySelector('[data-mobile-submit]');
    this.mobilePrice = productInfo.querySelector('[data-mobile-price]');
    this.buyRegion = productInfo.querySelector('[data-main-buy-buttons]');
    this.footer = document.querySelector('.gv2-footer');
    this.unsubscribers = [];
    this.initialize();
  }

  get mainButton() {
    return this.productInfo.querySelector(`#ProductSubmitButton-${this.sectionId}`);
  }

  get priceRegion() {
    return this.productInfo.querySelector(`#price-${this.sectionId}`);
  }

  get saleBadge() {
    return this.productInfo.querySelector('[data-sale-badge]');
  }

  initialize() {
    if (this.mobileButton) {
      this.mobileButton.addEventListener('click', () => {
        const button = this.mainButton;
        if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
      });
    }

    if (this.buyRegion && this.mobileBar) {
      this.purchaseObserver = new IntersectionObserver(
        ([entry]) => this.mobileBar.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.15 }
      );
      this.purchaseObserver.observe(this.buyRegion);
    }

    if (this.footer && this.mobileBar) {
      this.footerObserver = new IntersectionObserver(
        ([entry]) => this.mobileBar.classList.toggle('is-footer-visible', entry.isIntersecting),
        { threshold: 0.01 }
      );
      this.footerObserver.observe(this.footer);
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      this.unsubscribers.push(
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.sectionId) return;
          window.requestAnimationFrame(() => {
            this.updateSaleBadge(data.variant);
            this.synchronizeMobileBar();
          });
        })
      );
    }

    const watchedRegion = this.productInfo.querySelector(`#ProductInfo-${this.sectionId}`);
    if (watchedRegion) {
      this.mutationObserver = new MutationObserver(() => this.synchronizeMobileBar());
      this.mutationObserver.observe(watchedRegion, { childList: true, subtree: true, attributes: true });
    }

    this.synchronizeMobileBar();
  }

  updateSaleBadge(variant) {
    if (!this.saleBadge || !variant) return;
    const compareAt = Number(variant.compare_at_price || 0);
    const price = Number(variant.price || 0);
    const percentage = compareAt > price ? Math.round(((compareAt - price) * 100) / compareAt) : 0;
    this.saleBadge.textContent =
      percentage > 0 ? this.saleBadge.dataset.saveTemplate.replace('[percent]', percentage) : '';
    this.saleBadge.classList.toggle('hidden', percentage === 0);
  }

  synchronizeMobileBar() {
    const button = this.mainButton;
    const price = this.priceRegion;
    if (this.mobilePrice && price) this.mobilePrice.innerHTML = price.innerHTML;
    if (!this.mobileButton || !button) return;

    const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
    const label = button.querySelector('span:not(.loading__spinner):not(.sold-out-message)');
    this.mobileButton.disabled = disabled;
    this.mobileButton.textContent = label?.textContent?.trim() || window.variantStrings?.soldOut || '';
  }

  disconnect() {
    this.purchaseObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.unsubscribers.forEach((unsubscribe) => unsubscribe?.());
  }
}

const initializeGravixProducts = (root = document) => {
  root.querySelectorAll('product-info.gv2-pdp:not([data-gv2-ready])').forEach((productInfo) => {
    productInfo.dataset.gv2Ready = 'true';
    productInfo.gravixProductV2 = new GravixProductV2(productInfo);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeGravixProducts());
document.addEventListener('shopify:section:load', (event) => initializeGravixProducts(event.target));
